import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

import { type Dialog, type Pagination, type Sort } from "../types";

const agentSection = "/agents/";

export const agentListPath = agentSection;

export enum AgentListUrlSortField {
  name = "name",
  status = "status",
  createdAt = "createdAt",
}

export type AgentListUrlDialog = "delete";

type AgentListUrlSort = Sort<AgentListUrlSortField>;
export type AgentListUrlQueryParams = AgentListUrlSort &
  Dialog<AgentListUrlDialog> &
  Pagination & { id?: string; query?: string; status?: string };

export const agentListUrl = (params?: AgentListUrlQueryParams) =>
  agentListPath + "?" + stringifyQs(params);

export const agentPath = (id: string) => urlJoin(agentSection, id);
export type AgentUrlDialog = "assign" | "unassign" | "settle" | "markPaid" | "markFailed" | "reopen";
export type AgentUrlQueryParams = Dialog<AgentUrlDialog> & { assignmentId?: string; payoutId?: string };
export const agentUrl = (id: string, params?: AgentUrlQueryParams) =>
  agentPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const agentAddPath = urlJoin(agentSection, "add");
export const agentAddUrl = agentAddPath;
